import * as constants from '@/common/constants';

export default {
    state: {
        showLeft: constants.VUEX_NAV_SHOW_LEFT,
        layoutType:constants.VUEX_LAYOUT_TYPE,

    },
    mutations: {
        [constants.VUEX_MUTATIONS_NAV_SHOW_LEFT]: (state, showLeft) => {
            state.showLeft = showLeft;
        },
        [constants.VUEX_MUTATIONS_LAYOUT_TYPE]: (state, layoutType) => {
            state.layoutType = layoutType;
        }
    },
    actions: {
        [constants.VUEX_ACTIONS_NAV_SHOW_LEFT] ({ commit }, showLeft) {
            commit(constants.VUEX_MUTATIONS_NAV_SHOW_LEFT, showLeft);
        },
        [constants.VUEX_ACTIONS_LAYOUT_TYPE] ({ commit }, layoutType) {
            commit(constants.VUEX_MUTATIONS_LAYOUT_TYPE, layoutType);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/store-nav-show-left.js